/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VrfContextModule
 */

/**
 * @description VRFContext collection dataSource.
 *
 * @author Alex Malisky, Aravindh Nagarajan, Sarthak Kapoor
 */

import { ListCollDataSource } from 'ajs/modules/data-model/factories/list-coll-data-source.factory';

export class VRFContextCollDataSource extends ListCollDataSource {
    constructor(args = {}) {
        const extendedArgs = {
            ...args,
            defaultParams: {
                includeName_: true,
            },
        };

        super(extendedArgs);
    }
}
